import { Business, Groups, Person } from '@mui/icons-material';
import { Badge, IconButton, Switch } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useSxStyles } from './useStyles';

type PropsType = {
  onToggle: () => void;
  checked: boolean;
  disabled: boolean;
};
export const AdminModeToggle = (props: PropsType) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();
  const { onToggle, checked, disabled } = props;

  return (
    <IconButton
      onClick={() => onToggle()}
      title={t('viewAllCompanyWorkspaces')}
      disabled={disabled}
      sx={sxStyles.button}
    >
      <Switch
        onChange={() => onToggle()}
        checked={checked}
        size={'small'}
        disabled={disabled}
      />
      <Badge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        badgeContent={<Business fontSize={'inherit'} color={'primary'} />}
        sx={{ '& .MuiBadge-badge': { fontSize: '1rem' } }}
      >
        {checked ? <Groups /> : <Person />}
      </Badge>
    </IconButton>
  );
};
